const MagistratMandataireStyle = {
  bg: "white",
  mt: 4,
};

const MagistratCommentsStyle = {
  flexWrap: "wrap",
  mt: "6",
  overFlow: "hidden",
  position: "relative",
};

export { MagistratMandataireStyle, MagistratCommentsStyle };
